import { render, staticRenderFns } from "./UnmatchedCardBack.vue?vue&type=template&id=3fe96289&"
import script from "./UnmatchedCardBack.vue?vue&type=script&lang=js&"
export * from "./UnmatchedCardBack.vue?vue&type=script&lang=js&"
import style0 from "./UnmatchedCardBack.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports